const ordersAllTrans = {
  "list-orders-all.helmet": "Tất cả đơn hàng",
  "list-orders-all.breadcrumb.title": "Danh sách đơn hàng",
  "list-orders-all.breadcrumb.parent": "Quản lý đơn hàng",
  "list-orders-all.col.date": "Ngày lên đơn",
  "list-orders-all.col.date.expiry": "Hạn sử dụng",
  "list-orders-all.col.code": "Mã đơn hàng",
  "list-orders-all.col.customer": "Khách hàng",
  "list-orders-all.col.products": "Sản phẩm",
  "list-orders-all.col.products.code": "Mã SP",
  "list-orders-all.col.products.barcode": "Mã vạch",
  "list-orders-all.col.products.name": "Tên SP",
  "list-orders-all.col.products.number": "Số lượng",
  "list-orders-all.col.payment": "Thanh toán",
  "list-orders-all.col.payment.cash": "Tiền mặt",
  "list-orders-all.col.payment.cod": "Thanh toán khi nhận hàng",
  "list-orders-all.col.payment.bank": "Chuyển khoản",
  "list-orders-all.modal.detail.title.customer": "Thông tin khách hàng",
  "list-orders-all.modal.detail.title.order": "Thông tin đơn hàng",
  "list-orders-all.modal.detail.title.staff": "Thông tin nhân viên",
  "list-orders-all.modal.name.label": "Tên khách hàng",
  "list-orders-all.modal.name.staff.label": "Tên nhân viên",
  "list-orders-all.modal.detail.total.order": "Tổng tiền thanh toán",

  "list-orders-all.modal.phone.label": "Số điện thoại",
  "list-orders-all.modal.address.label": "Địa chỉ",
  "list-orders-all.modal.order-code.label": "Mã đơn",
  "list-orders-all.modal.order-status.label": "Hình thức thanh toán",
  "list-orders-all.modal.created.label": "Ngày lên đơn",
  "list-orders-all.modal.note.label": "Ghi chú đơn hàng",
  "list-orders-all.modal.status.label": "Trạng thái đơn hàng",
  "list-orders-all.modal.items.label": "Danh sách sản phẩm",
  "list-orders-all.modal.items.stt.col": "STT",
  "list-orders-all.modal.items.info.col": "Thông tin sản phẩm",
  "list-orders-all.modal.items.name.col": "Tên SP",
  "list-orders-all.modal.items.code.col": "Mã SP",
  "list-orders-all.modal.items.barcode.col": "Mã vạch",
  "list-orders-all.modal.items.unit.col": "Đơn vị tính",
  "list-orders-all.modal.items.source.col": "Xuất xứ",
  "list-orders-all.modal.items.desc.col": "Ghi chú",
  "list-orders-all.modal.items.number.col": "Số lượng",
  "list-orders-all.modal.items.number.quantity.col": "Đặt",
  "list-orders-all.modal.items.number.return.col": "Trả",
  "list-orders-all.modal.items.price.col": "Đơn giá",
  "list-orders-all.modal.items.discount.col": "Giảm giá",
  "list-orders-all.modal.items.total.col": "Thành tiền",
  "list-orders-all.modal.discount.label": "Giảm giá",
  "list-orders-all.modal.discount_percentage.label": "Chiết khấu đơn hàng (%)",
  "list-orders-all.modal.discount_percentage.placeholder": "Nhập chiết khấu",
  "list-orders-all.modal.total.label": "Tổng cộng",
  "list-orders-all.title-empty": "(Chưa có dữ liệu)",
  "list-orders-all.note.copy": "Copy thông tin khách hàng thành công",
  "list-orders-all.btn.detail": "Chi tiết đơn hàng",
  "list-orders-all.btn.confirm": "Duyệt đơn hàng",
  "list-orders-all.btn.reset": "Trở về trạng thái trước đó",
  "list-orders-all.btn.update.complete": "Cập nhật trạng thái hoàn thành",

  "list-orders-all.btn.return": "Trả hàng",
  "list-orders-all.modal.header.detail.title": "Chi tiết thông tin đơn hàng",
  "list-orders-all.modal.header.return.title": "Trả hàng",
  "list-orders-all.modal.header.cancel.title":
    "Chi tiết thông tin hủy đơn hàng",
  "list-orders-all.modal.header.update.title": "Điều phối đơn hàng",
  "list-orders-all.note.create-order-return.success": "Trả hàng thành công!",
  "list-orders-all.note.create-order-return.failure":
    "Trả hàng không thành công! Vui lòng kiểm tra lại trạng thái hoặc số lượng trả hàng của đơn hàng",
  "list-orders-all.guest": "Khách vãng lai",
  "list-orders-all.col.info.customer": "Thông tin người nhận",
  "list-orders-all.col.status.order": "Trạng thái",
  "list-orders-all.col.single.maker": "Người tạo đơn",
  "list-orders-all.col.date.wholesale": "Ngày tạo đơn",
  "order.preview": "Xem trước",
  "order.modal.update.confirm.title": "Xác nhận cập nhật trạng thái đơn hàng",
  "order.modal.update.confirm.description":
    "Bạn chắc chắn muốn cập nhật trạng thái đơn hàng?",
  "order.modal.delete.confirm.title": "Xác nhận hủy đơn hàng",
  "order.modal.delete.confirm.description": "Bạn chắc chắn muốn hủy đơn hàng?",
  "order.modal.cancel.title": "Hủy đơn hàng",
  "order.modal.cancel.full": "Hủy toàn bộ đơn hàng",
  "order.modal.cancel.partial": "Hủy một phần",
  "order.modal.cancel.quantity.col": "SL hủy",
  "order.modal.delete.reason": "Lý do hủy",

  "order-modal.update-order-status.failure":
    "Cập nhật không thành công vui lòng kiểm tra lại số lượng của từng sản phẩm trong đơn hàng",
  "order-modal.update-order-status.success": "Cập nhật thành công",
  "order-modal.cancel-order.success": "Hủy đơn thành công",
  "order-modal.cancel-order.failure": "Hủy đơn thất bại",
  "order-modal.confirm-order.success": "Duyệt đơn hàng thành công",
  "order-modal.confirm-order.error": "Duyệt đơn hàng thất bại",
};

const vatTrans = {
  "order.vat.create": "Thêm hóa đơn vat",
  "order.vat.list": "Danh sách hóa đơn vat",
  "order.vat.edit": "Cập nhật hóa đơn vat",
  "order.vat.delete": "Xóa hóa đơn vat",
  "order.vat.manage": "Quản lý hóa đơn vat",
  "order.vat.create.confirm": "Xác nhận tạo hóa đơn vat",
  "order.vat.create.confirmSure": "Bạn chắc chắn tạo hóa đơn vat?",
  "order.vat.edit.confirm": "Xác nhận cập nhật hóa đơn vat",
  "order.vat.edit.confirmSure": "Bạn chắc chắn cập nhật hóa đơn vat?",
  "order.vat.create.success": "Tạo hóa đơn vat thành công",
  "order.vat.update.success": "Cập nhật hóa đơn vat thành công",
  "order.vat.delete.confirm": "Xác nhận xóa hóa đơn vat",
  "order.vat.delete.confirmSure": "Bạn chắc chắn xóa hóa đơn vat?",
  "order.vat.delete.success": "Xóa hóa đơn vat thành công",

  "order.vat.title": "Xuất hóa đơn VAT",
  "order.vat.name": "Tên khách hàng",
  "order.vat.name.required": "Vui lòng nhập tên khách hàng",
  "order.vat.email": "Email",
  "order.vat.email.invalid": "Email không đúng định dạng",
  "order.vat.phone": "Số điện thoại",
  "order.vat.phone.invalid": "Số điện thoại không đúng định dạng",
  "order.vat.taxcode": "Mã số thuế",
  "order.vat.taxcode.required": "Vui lòng nhập mã số thuế",
  "order.vat.percent": "Phần trăm phụ thu",
  "order.vat.percent.money": "Phụ thu",
  "order.vat.address": "Địa chỉ",
  "order.vat.address.required": "Vui lòng nhập địa chỉ",
  "order.vat.order": "Thông tin bàn",
  "order.vat.btn-1": "Xuất hóa đơn",
  "order.vat.noti-update-vat-success": "Xuất hóa đơn thành công",
};

const vnLangOrder = {
  ...vatTrans,
  ...ordersAllTrans,
};

export default vnLangOrder;
